@if (profileUrl) {
  <a class="flex" [routerLink]="profileUrl" data-id="view-profile">
    <ng-container *ngTemplateOutlet="avatarTemplate" />
  </a>
} @else {
  <rma-profile-avatar
    class="flex-shrink-0"
    [ngClass]="avatarSize === 'standard' ? ['h-16', 'w-16'] : ['h-20', 'w-20']"
    [avatar]="avatar"
    [name]="name"
    [profileType]="profileType"
    [lazyLoad]="lazyLoadAvatar"
    [backgroundColour]="backgroundColour" />
}

<div class="ml-4 flex h-16 flex-col justify-center space-y-1" [class.!h-20]="avatarSize === 'large'">
  <p class="!mb-0 line-clamp-1 font-bold" [innerHTML]="name"></p>
  <ng-content />
  @if (ratingValue) {
    <div class="flex items-center">
      <rma-short-rating-summary [rating]="ratingValue" [count]="reviewCount ?? 0" />
    </div>
  }
</div>

<ng-template #avatarTemplate>
  <rma-profile-avatar
    class="flex-shrink-0"
    [ngClass]="avatarSize === 'standard' ? ['h-16', 'w-16'] : ['h-20', 'w-20']"
    [avatar]="avatar"
    [name]="name"
    [profileType]="profileType"
    [lazyLoad]="lazyLoadAvatar"
    [backgroundColour]="backgroundColour" />
</ng-template>
